import { Box } from '@material-ui/core';
import React, { useCallback, useImperativeHandle, useState } from 'react';
import { IBundlePackage, IBundleVariant, IStory } from '../../services/types';
import BundlePackageItem from '../bundlePackage/BundlePackageItem';

interface IBundleVariantProps {
  story: IStory;
  variant: IBundleVariant;
  no: number;
  onChangeVariantProps: (kv: any) => void;
  removeVariant: () => void;
  editable: boolean;
}

export interface IBundleVariantImperativeHandle {
  getValidationMessage: () => string[];
}

const BundleVariant = (props: IBundleVariantProps, ref: React.Ref<IBundleVariantImperativeHandle> | undefined): JSX.Element => {
  const { story, variant, no, onChangeVariantProps, removeVariant, editable = false } = props;
  const { bundles } = variant.data;
  const [validationMessage, setValidationMessage] = useState<string[]>([]);

  const handleChange = (bundles: IBundlePackage[]) => {
    onChangeVariantProps({ bundles });
  };

  const handleValidate = useCallback(validationMessages => {
    setValidationMessage(validationMessages);
  }, []);

  useImperativeHandle<unknown, IBundleVariantImperativeHandle>(
    ref,
    () => {
      const getValidationMessage = () => validationMessage;

      return { getValidationMessage };
    },
    [validationMessage],
  );

  return (
    <Box>
      {story && (
        <Box marginBottom={3} key={`${variant.id}-${story.id}-${no}`}>
          <BundlePackageItem
            title={`Bundle Packages ${no}`}
            story={story}
            bundles={bundles}
            isEditing={editable}
            removable={editable}
            onChange={handleChange}
            onRemoveClick={removeVariant}
            onValidate={handleValidate}
          />
        </Box>
      )}
    </Box>
  );
};

export default React.forwardRef(BundleVariant);
